/* eslint-disable no-unused-vars */
function initSmallLayoutAnimations() {
  // Standard to top link animation
  $('.top-link').on('click', () => {
    $('body,html').animate({
      scrollTop: 0,
    }, 800);
  });
}

window.addEventListener('scroll', function(){
  const progressBar = document.getElementById("progressBar");
  if (!progressBar) {
    return;
  }

  const scrollTop = window.scrollY || document.documentElement.scrollTop;
  const docHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
  const scrolled = (scrollTop / docHeight) * 100;
  progressBar.style.width = `${scrolled}%`;
});
